module.exports = __webpack_public_path__ + "static/media/square-full.fa95c30e.svg";